import { TELE_CONSULT_PRODUCT } from "opsComponents/subsOrders/constants";

import { ProductNameType, RegionType, StripeProductModel } from "graphql/generated";
import { CURRENT_COUNTRY } from "src/constants/Countries";

const CURRENCY_BY_COUNTRY = {
  [RegionType.Sg]: "$",
  [RegionType.Hk]: "HK$",
  [RegionType.Jp]: "¥"
};

export const CURRENCY = CURRENCY_BY_COUNTRY[CURRENT_COUNTRY];

export const checkIsTeleConsultProduct = (
  product: Pick<StripeProductModel, "uniqName">
): boolean => {
  if (!product) {
    return false;
  }

  return TELE_CONSULT_PRODUCT.includes(product.uniqName as ProductNameType);
};
